import CaretRight from 'components/icons/navigation/CaretRight';

const GraceListRowLink = ({ displayText, photo, onClick }) => {
  return (
    <button
      className="flex w-full content-center border-b border-charcoal-60 px-6 py-4 text-left hover:bg-charcoal-50"
      onClick={e => {
        e.currentTarget.disabled = true;
        onClick();
        e.currentTarget.disabled = false;
      }}
      key={displayText}
    >
      {photo && (
        <div className="mr-4 h-12 w-12">
          <img
            src={photo}
            className="min-h-12 min-w-12 rounded-sm object-cover"
            alt={displayText}
          />
        </div>
      )}
      <span className={'mr-2 flex flex-grow self-center'}>{displayText}</span>
      <CaretRight className="iconMd iconPrimary ml-4 self-center" />
    </button>
  );
};

GraceListRowLink.propTypes = {
  displayText: PropTypes.string.isRequired,
  photo: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default GraceListRowLink;
